import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'on-common/_services/toast.service';
import { ElectronicInvoicingEntity } from 'on-shared/_models/ElectronicInvoicingEntity';
import { CompanyService } from 'on-shared/stores/company/company.service';
import { EInvoicingEntityModalComponent } from './einvoicing-entity-modal/einvoicing-entity-modal.component';

@Component({
    selector: 'on-einvoicing-tab',
    templateUrl: './einvoicing-tab.component.html',
    styleUrls: ['./einvoicing-tab.component.scss'],
})
export class EInvoicingTabComponent implements OnInit {
    isLoading = false;
    entities: ElectronicInvoicingEntity[] = [];

    constructor(
        private companyService: CompanyService,
        private toastService: ToastService,
        private translate: TranslateService,
        private bsModal: NgbModal,
    ) {}

    ngOnInit() {
        this.getEntities();
    }

    reload() {
        this.getEntities();
    }

    getEntities() {
        this.isLoading = true;
        this.companyService.GetElectronicInvoicingEntities().subscribe(
            (response) => {
                this.entities = response.Result;
                this.isLoading = false;
            },
            () => {
                this.toastService.error(
                    this.translate.instant('company.einvoicing.load-error'),
                );
                this.isLoading = false;
            },
        );
    }

    openEntityModal(entity?: ElectronicInvoicingEntity) {
        const modal = this.bsModal.open(EInvoicingEntityModalComponent);
        modal.componentInstance.entity = entity
            ? new ElectronicInvoicingEntity(entity)
            : null;

        modal.result.then(
            () => {
                this.getEntities();
            },
            () => {},
        );
    }
}
